<template>
  <div>
    <div id="AddFakeExel" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">بارگذاری اکسل ربات‌ها</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <p class="text-muted mb-3">
                نام شیت: <strong>FakeUserNames</strong> (یا Sheet1). سطر اول هدر است. برای لیست assetها، شناسه‌های
                MongoDB را با کاما، سمی‌کالن یا | جدا کنید.
              </p>
              <div class="table-responsive mb-4">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>ستون</th>
                      <th>فیلد</th>
                      <th>توضیح</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>A</td><td>username</td><td>نام کاربری (الزامی)</td></tr>
                    <tr><td>B</td><td>level</td><td>سطح پایه (عدد، پیش‌فرض ۱)</td></tr>
                    <tr><td>C</td><td>gender</td><td>جنسیت: girl / boy یا دخترونه / پسرونه</td></tr>
                    <tr><td>D</td><td>avatars</td><td>لیست شناسه آواتارها</td></tr>
                    <tr><td>E</td><td>selectedAvatar</td><td>شناسه آواتار انتخاب‌شده</td></tr>
                    <tr><td>F</td><td>skins</td><td>لیست شناسه مهره‌ها</td></tr>
                    <tr><td>G</td><td>selectedSkin</td><td>شناسه مهره انتخاب‌شده</td></tr>
                    <tr><td>H</td><td>formations</td><td>لیست شناسه ترکیب‌ها</td></tr>
                    <tr><td>I</td><td>selectedFormation</td><td>شناسه ترکیب انتخاب‌شده</td></tr>
                    <tr><td>J</td><td>boots</td><td>لیست شناسه کفش‌ها</td></tr>
                    <tr><td>K</td><td>selectedBoot</td><td>شناسه کفش انتخاب‌شده</td></tr>
                  </tbody>
                </table>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-3 form-control-label d-flex justify-content-lg-end">انتخاب فایل اکسل</label>
                <div class="col-lg-9">
                  <input
                    type="file"
                    class="form-control"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    id="fakeExcelFile"
                    name="fakeExcelFile"
                    @change="fileSelectet"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-shadow" data-dismiss="modal">بستن</button>
              <button type="submit" class="btn btn-primary" @click="handleClick">بارگذاری</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      file: null,
    };
  },
  methods: {
    handleClick() {
      if (!this.file) return window.notif({ isError: true, mssg: 'فایلی انتخاب نکرده اید' });
      this.$emit('clicked', this.file);
      this.file = null;
      const input = document.getElementById('fakeExcelFile');
      if (input) input.value = '';
    },
    fileSelectet(e) {
      this.file = e.target.files[0];
    },
  },
};
</script>
